import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { ProgressBar } from '@xing-com/progress-bar';
import {
  spaceL,
  spaceM,
  spaceXXL,
  xdlColorText,
  xdlColorBackgroundTertiary,
} from '@xing-com/tokens';
import { Meta } from '@xing-com/typography';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${spaceL};
  background: ${xdlColorBackgroundTertiary};
  padding: 7px ${spaceM} ${spaceM} ${spaceM};
`;

export const StyledProgressbar = styled(ProgressBar)`
  padding: ${spaceM} ${spaceXXL} 0 0;
  width: 100%;
`;

export const StyledButton = styled(Button)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
`;

export const StyledMeta = styled(Meta)`
  margin: 0;

  && {
    color: ${xdlColorText};
  }
`;
